import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

export function formatPercentage(value: number | Nullish) {
  if (isNil(value)) {
    return;
  }

  return `${Math.round(value * 100)} %`;
}
